export default __webpack_public_path__ + "media/digital.aa7da87e.svg";